import { Application } from "@hotwired/stimulus"

// Because of the way webpack loads the module we have to use the umd.js file
import AutoSubmit from '@stimulus-components/auto-submit/dist/stimulus-auto-submit.umd.js'
import CharacterCounter from '@stimulus-components/character-counter/dist/stimulus-character-counter.umd.js'
import Clipboard from '@stimulus-components/clipboard/dist/stimulus-clipboard.umd.js'
import RailsNestedForm from '@stimulus-components/rails-nested-form/dist/stimulus-rails-nested-form.umd.js'
import TextareaAutogrow from './textarea_autogrow_controller'

const application = Application.start()
application.register('auto-submit', AutoSubmit)
application.register('character-counter', CharacterCounter)
application.register('clipboard', Clipboard)
application.register('nested-form', RailsNestedForm)
application.register('textarea-autogrow', TextareaAutogrow)

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
